export const appBarConstants = {
  menuId: 'primary-search-account-menu',
  mobileMenuId: 'primary-search-account-menu-mobile',
  drawerWidth: 260,
}
